// Mock data for portfolio website

export const portfolioData = {
  hero: {
    name: "Pavlos Pozidis",
    title: "Web Developer • Graphic Designer • IT Support",
    subtitle: "Crafting digital experiences with clean code and creative design",
    cta: "View My Work",
    ctaSecondary: "Get In Touch"
  },
  
  about: {
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=800&fit=crop",
    bio: "I'm a multidisciplinary tech professional with a passion for creating seamless digital experiences. With expertise spanning web development, graphic design, and IT support, I bring a unique perspective to every project—combining technical precision with creative vision.",
    highlights: [
      { number: "50+", label: "Projects Completed" },
      { number: "5+", label: "Years Experience" },
      { number: "30+", label: "Happy Clients" }
    ]
  },
  
  skills: [
    {
      category: "Web Development",
      icon: "Code",
      items: ["React.js", "Node.js", "Python", "JavaScript", "TypeScript", "HTML/CSS", "REST APIs", "MongoDB"]
    },
    {
      category: "Graphic Design",
      icon: "Palette",
      items: ["Adobe Photoshop", "Illustrator", "Figma", "UI/UX Design", "Brand Identity", "Typography", "Color Theory", "Prototyping"]
    },
    {
      category: "IT Support",
      icon: "Server",
      items: ["System Administration", "Network Setup", "Troubleshooting", "Cloud Services", "Security", "Hardware", "Linux", "Windows Server"]
    },
    {
      category: "Tools & Others",
      icon: "Wrench",
      items: ["Git", "Docker", "AWS", "Webpack", "Agile", "CI/CD", "Testing", "DevOps"]
    }
  ],
  
  projects: [
    {
      id: 1,
      title: "E-Commerce Platform",
      category: "Web Development",
      description: "Full-stack e-commerce solution with real-time inventory management and payment integration.",
      image: "https://images.unsplash.com/photo-1557821552-17105176677c?w=800&h=600&fit=crop",
      tags: ["React", "Node.js", "MongoDB", "Stripe"],
      link: "#"
    },
    {
      id: 2,
      title: "Brand Identity Design",
      category: "Graphic Design",
      description: "Complete brand identity package including logo, color palette, and brand guidelines for a tech startup.",
      image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=600&fit=crop",
      tags: ["Illustrator", "Figma", "Branding"],
      link: "#"
    },
    {
      id: 3,
      title: "Corporate Network Setup",
      category: "IT Support",
      description: "Designed and implemented secure network infrastructure for a 100+ employee organization.",
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=600&fit=crop",
      tags: ["Networking", "Security", "Cloud"],
      link: "#"
    },
    {
      id: 4,
      title: "SaaS Dashboard",
      category: "Web Development",
      description: "Analytics dashboard with real-time data visualization and custom reporting features.",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
      tags: ["React", "D3.js", "REST API"],
      link: "#"
    },
    {
      id: 5,
      title: "Mobile App UI/UX",
      category: "Graphic Design",
      description: "User interface design for a fitness tracking mobile application with focus on accessibility.",
      image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=600&fit=crop",
      tags: ["Figma", "UI/UX", "Mobile"],
      link: "#"
    },
    {
      id: 6,
      title: "Cloud Migration",
      category: "IT Support",
      description: "Migrated legacy systems to AWS cloud infrastructure with zero downtime.",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=600&fit=crop",
      tags: ["AWS", "DevOps", "Migration"],
      link: "#"
    }
  ],
  
  experience: [
    {
      id: 1,
      year: "2022 - Present",
      title: "Senior Full Stack Developer",
      company: "TechCorp Solutions",
      description: "Leading development of enterprise web applications and mentoring junior developers."
    },
    {
      id: 2,
      year: "2020 - 2022",
      title: "UI/UX Designer",
      company: "Creative Digital Agency",
      description: "Designed user interfaces and experiences for various client projects across multiple industries."
    },
    {
      id: 3,
      year: "2019 - 2020",
      title: "IT Support Specialist",
      company: "Enterprise Tech Services",
      description: "Provided technical support and managed IT infrastructure for corporate clients."
    },
    {
      id: 4,
      year: "2018 - 2019",
      title: "Freelance Web Developer",
      company: "Self-Employed",
      description: "Built custom websites and web applications for small businesses and startups."
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "CEO, StartupHub",
      content: "Alex delivered an outstanding website that exceeded our expectations. His attention to detail and technical expertise made the entire process smooth and efficient.",
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop"
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Marketing Director, BrandCo",
      content: "Working with Alex was a pleasure. The brand identity he created perfectly captured our vision and has helped us stand out in a crowded market.",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop"
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      role: "CTO, DataFlow Inc",
      content: "Alex's IT support and network setup services were invaluable. He solved complex problems quickly and ensured our systems run smoothly.",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop"
    }
  ],
  
  contact: {
    email: "pozidis3@gmail.com",
    phone: "+1 (555) 123-4567",
    location: "San Francisco, CA",
    social: {
      github: "https://github.com",
      linkedin: "https://linkedin.com",
      twitter: "https://twitter.com",
      dribbble: "https://dribbble.com"
    }
  }
};
